import React from 'react';

export interface ButtonProps {
  value: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
}

const Button = ({
  value,
  onClick,
  type = 'button',
  className = 'bg-green shadow text-white text-base font-bold p-15',
  disabled = false,
}: ButtonProps) => {
  const disabledCursor = disabled ? 'cursor-not-allowed' : '';

  return (
    <button
      onClick={onClick}
      type={type}
      className={`${className} gb-btn ${disabledCursor}`.trim()}
      disabled={disabled}
    >
      {value}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.tsx